// @ts-nocheck: converted from JS

import Show from '@/components/Studies/Show';

export default Show;
